<div class="file-upload-wrapper">
  @let control = getControl();
  @let file = control.value;

  <div class="file-upload-container"
       (click)="getControl().disabled || fileUpload.click()"
       (keydown.enter)="getControl().disabled || fileUpload.click()"
       (keydown.space)="getControl().disabled || fileUpload.click()"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       [class.dragover]="isDragging()"
       [class.disabled]="getControl().disabled"
       [class.error]="getControl().invalid && !getControl().untouched"
       [attr.aria-disabled]="getControl().disabled"
       role="button"
       [attr.tabindex]="getControl().disabled ? -1 : 0">
    <div class="file-upload-content">
      <htx-icon class="upload-icon" [icon]="uploadIcon()"></htx-icon>
      <div class="upload-text">
        @if (file) {
          <p class="file-name">{{ file.name }}</p>
          <p class="file-size">{{ formatFileSize(file.size) }}</p>
          <p class="file-hint">{{ changeText() || 'Change file' }}</p>
        } @else {
          <p class="upload-label">{{ uploadText() || 'Upload file' }}</p>
          <p class="upload-hint">{{ dragDropText() || 'or drag and drop' }}</p>
        }
      </div>
    </div>
  </div>

  <input [hidden]="true" type="file" (change)="onFileSelected($event)" [attr.accept]="acceptedFileTypes()" #fileUpload>
</div>
